import identify from './identify';
import polling from './polling';
import errorTagging from './errorTagging';

module.exports = [...identify, polling, errorTagging];
